import { useAuth } from '@/contexts/AuthContext';

/** Message shown on write actions disabled for backoffice viewers. */
export const VIEWER_NO_PERMISSION = 'You do not have permission';

/** Message shown on the shadow-access toggle for internal viewers. */
export const NO_CLIENT_ACCESS = 'Internal viewers cannot open client accounts';

/**
 * True when the current backoffice member holds a read-only role ("viewer" or
 * "internal_viewer"). Used to disable write actions in the UI; the backend
 * enforces regardless.
 */
export const useIsViewer = (): boolean => {
  const { user } = useAuth();
  return user?.role === 'viewer' || user?.role === 'internal_viewer';
};

/**
 * Onboarding appointments are editable by viewers (Jovan, 2026-09-04) —
 * internal viewers stay read-only, as everywhere else.
 */
export const useCanEditAppointments = (): boolean => {
  const { user } = useAuth();
  return user?.role !== 'internal_viewer';
};

/**
 * The agency submission-usage count is editable by viewers. Internal viewers
 * stay read-only, as everywhere else.
 */
export const useCanEditSubmissionUsage = (): boolean => {
  const { user } = useAuth();
  return user?.role !== 'internal_viewer';
};

/**
 * Internal viewers are excluded from shadow access by design — the role
 * exists to keep them out of client accounts, and the grant covers the
 * whole team at once.
 */
export const useCanShadowAccess = (): boolean => {
  const { user } = useAuth();
  return user?.role !== 'internal_viewer';
};
